import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";

import { Button } from "@/components/ui/button";

import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

export default function HotelSelector({
  hotels = [],
  value = "",
  onSelect,
}) {
  const [open, setOpen] = useState(false);

  const selected = hotels.find(
    (h) => h.name === value
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          className="w-full justify-between"
        >
          {selected
            ? selected.name
            : "Search hotel..."}

          <ChevronsUpDown className="ml-2 h-4 w-4 opacity-50" />
        </Button>
      </PopoverTrigger>

      <PopoverContent className="w-[550px] p-0">
        <Command>
          <CommandInput placeholder="Search hotel..." />

          <CommandList>
            <CommandEmpty>
              Hotel not found
            </CommandEmpty>

            <CommandGroup>
              {hotels.map((hotel) => (
                <CommandItem
                  key={hotel.id}
                  value={`${hotel.name} ${hotel.location_type}`}
                  onSelect={() => {
                    onSelect(hotel);
                    setOpen(false);
                  }}
                >
                  <Check
                    className={`mr-2 h-4 w-4 ${
                      value === hotel.name
                        ? "opacity-100"
                        : "opacity-0"
                    }`}
                  />

                  <div>
                    <div className="font-medium">
                      {hotel.name}
                    </div>

                    <div className="text-xs text-muted-foreground">
                      {hotel.location_type} • ⭐ {hotel.rating}
                    </div>
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
